import { render, staticRenderFns } from "./TestReportUserType.vue?vue&type=template&id=5c9132a0&"
import script from "./TestReportUserType.vue?vue&type=script&lang=ts&"
export * from "./TestReportUserType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports